export default "__VITE_ASSET__915293da__"